'use client';

import { c as _c } from "react/compiler-runtime";
import { Slider as SliderPrimitive } from '@base-ui/react/slider';
import { cn } from '@repo/ui/lib/utils';
function Slider(t0) {
  const $ = _c(55);
  let className;
  let defaultValue;
  let props;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      defaultValue,
      max: t1,
      min: t2,
      value,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = defaultValue;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = value;
  } else {
    className = $[1];
    defaultValue = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    value = $[6];
  }
  const max = t1 === undefined ? 100 : t1;
  const min = t2 === undefined ? 0 : t2;
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== className || $[8] !== defaultValue || $[9] !== max || $[10] !== min || $[11] !== props || $[12] !== value) {
    const _values = value ?? defaultValue ?? [min, max];
    T1 = SliderPrimitive.Root;
    if ($[31] !== className) {
      t8 = cn("data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full", className);
      $[31] = className;
      $[32] = t8;
    } else {
      t8 = $[32];
    }
    t9 = "slider";
    t10 = defaultValue;
    t11 = max;
    t12 = min;
    t13 = "edge";
    t14 = value;
    t15 = props;
    t16 = "SliderPrimitive.Root";
    t17 = "Slider";
    t18 = "slider.tsx";
    T0 = SliderPrimitive.Control;
    t3 = "relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col";
    t4 = "SliderPrimitive.Control";
    t5 = "slider.tsx";
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <SliderPrimitive.Track className="relative grow overflow-hidden rounded-full bg-muted data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5" data-slot="slider-track" data-sentry-element="SliderPrimitive.Track" data-sentry-source-file="slider.tsx"><SliderPrimitive.Indicator className="bg-primary data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full" data-slot="slider-range" data-sentry-element="SliderPrimitive.Indicator" data-sentry-source-file="slider.tsx" /></SliderPrimitive.Track>;
      $[33] = t6;
    } else {
      t6 = $[33];
    }
    t7 = Array.from({
      length: _values.length
    }, _temp);
    $[7] = className;
    $[8] = defaultValue;
    $[9] = max;
    $[10] = min;
    $[11] = props;
    $[12] = value;
    $[13] = T0;
    $[14] = T1;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
    $[23] = t18;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    T0 = $[13];
    T1 = $[14];
    t10 = $[15];
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
    t14 = $[19];
    t15 = $[20];
    t16 = $[21];
    t17 = $[22];
    t18 = $[23];
    t3 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
  }
  let t19;
  if ($[34] !== T0 || $[35] !== t3 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 || $[39] !== t7) {
    t19 = <T0 className={t3} data-sentry-element={t4} data-sentry-source-file={t5}>{t6}{t7}</T0>;
    $[34] = T0;
    $[35] = t3;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== T1 || $[42] !== t10 || $[43] !== t11 || $[44] !== t12 || $[45] !== t13 || $[46] !== t14 || $[47] !== t15 || $[48] !== t16 || $[49] !== t17 || $[50] !== t18 || $[51] !== t19 || $[52] !== t8 || $[53] !== t9) {
    t20 = <T1 className={t8} data-slot={t9} defaultValue={t10} max={t11} min={t12} thumbAlignment={t13} value={t14} {...t15} data-sentry-element={t16} data-sentry-component={t17} data-sentry-source-file={t18}>{t19}</T1>;
    $[41] = T1;
    $[42] = t10;
    $[43] = t11;
    $[44] = t12;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
    $[51] = t19;
    $[52] = t8;
    $[53] = t9;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
}
function _temp(_, index) {
  return <SliderPrimitive.Thumb className="block size-4 shrink-0 rounded-full border border-primary bg-background shadow-sm ring-ring/50 transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50" data-slot="slider-thumb" key={index} />;
}
export { Slider };